import { createStyles, Link, List, ListItem, makeStyles, Menu, MenuItem, Theme, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Button as KendoButton } from '@progress/kendo-react-buttons';
import { Dialog } from '@progress/kendo-react-dialogs';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { LantisPageCounterBlModel } from '../../../../Restful/LantisApi';
import { useGlobalStyles } from '../../../../ui/old/themes/patrimoniumTheme';
import { applicationsItemsSelector } from '../../ducks/navbar';
import MosaicLink from './MosaicLink';
import { useLogOutMutation } from '../../../../Hooks';
import { msalInstance } from '../../../auth';
import Person2Icon from '@mui/icons-material/Person2';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            marginBottom: theme.spacing(5),
        },
        appBar: {
            backgroundColor: 'rgb(141, 217, 200)',
        },
        toolbar: {
            justifyContent: 'space-between',
            padding: '5px 1rem',

            [theme.breakpoints.up('lg')]: {
                padding: '5px 6.5rem',
            },
        },
        brandLogo: {
            height: 25,

            [theme.breakpoints.up('sm')]: {
                height: 50,
            },
        },
        brandLink: {
            fontSize: 20,
            color: '#0d273e',

            [theme.breakpoints.up('sm')]: {
                fontSize: 32,
                margin: '0 auto 0 1rem',
            },
        },
        dropdownMenuItem: {
            color: '#0D273E',
            fontWeight: 500,
        },
        mosaicItemPaper: {
            width: 280,
            boxSizing: 'border-box',
            top: '55px !important',
        },
        simpleItemPaper: {
            top: '55px !important',
        },
        simpleItemPaperLogout: {
            top: '55px !important',
            left: '89vw !important',
        },
        mosaicItemList: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
        mosaicItem: {
            backgroundSize: '80px 80px',
            margin: theme.spacing(1) / 4,
            width: '80px',
            height: '80px',
            position: 'relative',
            cursor: 'pointer',
            padding: '0 0px',
            display: 'inline-block',
            objectFit: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#8dd9c8',
            transition: 'transform .2s ease-in-out',
            transform: 'scale(1)',

            '&:hover': {
                transform: 'scale(1.1)',
                zIndex: 100,
            },
        },
        mosaicItemOverlay: {
            opacity: 0,
            position: 'absolute',
            left: '0px',
            right: '0px',
            top: '0px',
            bottom: '0px',
            transition: 'opacity .2s ease-in-out',
            background: 'rgba(0, 0, 0, 0.4)',

            '&:hover': {
                opacity: 1,
            },
        },
        mosaicItemText: {
            color: '#fff',
            margin: '0',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            whiteSpace: 'normal',
            overflowWrap: 'break-word',
        },
        simpleButton: {
            textTransform: 'none',
            fontSize: '1.25em',

            '&:hover': {
                backgroundColor: 'inherit',
            },
        },
        simpleButtonFocus: {
            backgroundColor: 'inherit',
        },
        simpleMenuItem: {
            padding: 0,
        },
        simpleLink: {
            display: 'block',
            padding: theme.spacing(0.5, 2),
            fontSize: '14px',
            color: '#0d273e',
        },
        button: {
            margin: '0 auto',
            display: 'block',
            marginBottom: '50px',
            backgroundColor: '#fff !important',

            '& .k-icon:first-child::before': { fontSize: '60px', marginLeft: '-20px', color: '#fff44f' },
        },
    }),
);

type NavigationProps = {
    className?: string;
};

const Navigation: React.FC<NavigationProps> = ({ className }) => {
    const classes = useStyles();
    const globalClasses = useGlobalStyles();
    const applicationItems = useSelector(applicationsItemsSelector);
    const { mutateAsync: logOutCache } = useLogOutMutation();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [raportAnchorEl, setRaportAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickRaport = (event: React.MouseEvent<HTMLButtonElement>) => {
        setRaportAnchorEl(event.currentTarget);
    };
    const handleCloseRaport = () => {
        setRaportAnchorEl(null);
    };

    const [userAnchorEl, setUserAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(userAnchorEl);
    const handleMenuUserClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setUserAnchorEl(event.currentTarget);
    };
    const handleUserClose = () => {
        setUserAnchorEl(null);
    };

    const [currentItem, setCurrentItem] = useState<LantisPageCounterBlModel | undefined>(undefined);
    const toggleDialog = (
        item: LantisPageCounterBlModel | undefined,
        e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>,
    ) => {
        e.preventDefault();
        setCurrentItem(item);
    };

    return (
        <>
            <List component="div" disablePadding className={className}>
                <ListItem disableGutters>
                    <div>
                        <Button
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={handleClick}
                            classes={{ root: classes.simpleButton }}
                            disableFocusRipple
                            disableRipple
                            disableElevation
                        >
                            Toepassingen <ArrowDropDownIcon style={{ fontSize: 30 }} />
                        </Button>
                        <Menu
                            classes={{ paper: classes.mosaicItemPaper, list: classes.mosaicItemList }}
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            {applicationItems
                                .filter((x) => x.typePage === 1)
                                .map((mosaicItem) => (
                                    <MenuItem
                                        onClick={handleClose}
                                        key={mosaicItem.lantisPageId}
                                        className={classes.mosaicItem}
                                        style={{
                                            backgroundImage: `url(${mosaicItem?.iconPathNetCore})`,
                                        }}
                                    >
                                        <MosaicLink
                                            className={classes.mosaicItemOverlay}
                                            mosaicItem={mosaicItem}
                                            toggleDialog={toggleDialog.bind(globalThis, mosaicItem)}
                                        >
                                            <div className={classes.mosaicItemText}>
                                                <Typography align="center">{mosaicItem.pageName}</Typography>
                                            </div>
                                        </MosaicLink>
                                    </MenuItem>
                                ))}
                        </Menu>
                    </div>
                </ListItem>
                <ListItem disableGutters>
                    <div>
                        <Button
                            aria-controls="simple-menu-raport"
                            aria-haspopup="true"
                            classes={{ root: classes.simpleButton }}
                            disableFocusRipple
                            disableRipple
                            href="/reports/reports-powerbi"
                            disableElevation
                        >
                            Rapporten
                        </Button>
                    </div>
                </ListItem>
                {applicationItems.filter((x) => x.typePage === 3).length > 0 ? (
                    <ListItem disableGutters>
                        <div>
                            <Button
                                aria-controls="simple-menu-admin"
                                aria-haspopup="true"
                                onClick={handleClickRaport}
                                classes={{ root: classes.simpleButton }}
                                disableFocusRipple
                                disableRipple
                                disableElevation
                            >
                                Admin <ArrowDropDownIcon style={{ fontSize: 30 }} />
                            </Button>
                            <Menu
                                classes={{ paper: classes.simpleItemPaper }}
                                id="simple-menu-admin"
                                anchorEl={raportAnchorEl}
                                keepMounted
                                open={Boolean(raportAnchorEl)}
                                onClose={handleCloseRaport}
                            >
                                {applicationItems
                                    .filter((x) => x.typePage === 3)
                                    .map((item) => (
                                        <MenuItem key={item.pageName} className={classes.simpleMenuItem}>
                                            <Link
                                                href={String(item.link)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                underline="none"
                                                className={classes.simpleLink}
                                            >
                                                {item.pageName}
                                            </Link>
                                        </MenuItem>
                                    ))}
                            </Menu>
                        </div>
                    </ListItem>
                ) : (
                    ''
                )}
                <ListItem disableGutters>
                    <div style={{ inlineSize: 'max-content' }}>
                        <Button
                            aria-controls="simple-menu-logout"
                            aria-haspopup="true"
                            classes={{ root: classes.simpleButton }}
                            disableFocusRipple
                            disableRipple
                            disableElevation
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleMenuUserClick}
                        >
                            <Person2Icon />
                            {msalInstance.getActiveAccount()?.name
                                ? `Hello, ${msalInstance.getActiveAccount()?.name}`
                                : ''}
                            <ArrowDropDownIcon style={{ fontSize: 30 }} />
                        </Button>
                        <Menu
                            classes={{ paper: classes.simpleItemPaperLogout }}
                            id="simple-menu-logout"
                            anchorEl={userAnchorEl}
                            keepMounted
                            open={Boolean(userAnchorEl)}
                            onClose={handleUserClose}
                        >
                            <MenuItem
                                className={classes.simpleLink}
                                onClick={async () => {
                                    await logOutCache();
                                    await msalInstance.logoutRedirect();
                                    handleUserClose();
                                }}
                            >
                                Logout
                            </MenuItem>
                        </Menu>
                    </div>
                </ListItem>
            </List>
            {currentItem && (
                <Dialog autoFocus={true}>
                    <KendoButton icon="warning" className={classes.button} disabled={true}></KendoButton>
                    <p>{currentItem.warningText}</p>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <KendoButton
                            type="button"
                            className={globalClasses.iconButton_variantPrimary}
                            primary={true}
                            onClick={(e) => setCurrentItem(undefined)}
                            style={{ color: '#fff', padding: 0 }}
                        >
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={currentItem!.link!}
                                style={{ color: 'white', textDecoration: 'none', padding: '8px 16px' }}
                            >
                                Ok
                            </a>
                        </KendoButton>
                        <KendoButton
                            type="button"
                            className={globalClasses.iconButton_variantSecondary}
                            primary={true}
                            onClick={toggleDialog.bind(globalThis, undefined)}
                            style={{ marginLeft: '20px', color: '#fff' }}
                        >
                            Cancel
                        </KendoButton>
                    </div>
                </Dialog>
            )}
        </>
    );
};

export default Navigation;
